import { JsonObject } from '@/lib/helpers';

export class PreferencesModel {
  sidebarOpen: boolean;

  constructor(props: JsonObject = {}) {
    const data = props as Record<keyof PreferencesModel, unknown>;
    this.sidebarOpen = typeof data.sidebarOpen === 'boolean' ? data.sidebarOpen : true;
  }
}
